import React, { useState, useEffect } from 'react';

import Profile from '../models/Profile';
import UserProfileFieldControl from './UserProfileFieldControl';
import ProfileFieldInputVm from '../models/ProfileFieldInputVm';

interface UserProfileFieldControlsProps {
  indicateErrorOnLoad: boolean;
  profile: Profile;
  values?: ProfileFieldInputVm[];
  hidden?: boolean;
  onChange?: (input: ProfileFieldInputVm) => void;
}

const UserProfileFieldControls = (props: UserProfileFieldControlsProps) => {
  const [values, setValues] = useState<ProfileFieldInputVm[]>();
  useEffect(() => {
    if (values !== props.values) {
      setValues(props.values);
    }
  }, [props.values]);

  const profileFields = props.profile.fields;
  const getProfileValue = (
    values: ProfileFieldInputVm[],
    profilekey: number,
    fieldposition: number) => {
    return values?.find(v => v.profilekey === profilekey && v.fieldposition === fieldposition)?.value;
  };

  const hasSubFields = props.profile?.fields?.length > 1;
  return (
    <>
    {
      profileFields.map(field => {
        const value = getProfileValue(values, field.profilekey, field.fieldposition);
        return (
          <UserProfileFieldControl
            key={`${field.profilekey}-${field.fieldposition}`}
            indicateErrorOnLoad={props.indicateErrorOnLoad}
            profileField={field}
            required={!hasSubFields && props.profile.required && field.required}
            value={value}
            hidden={props.hidden}
            onChange={props.onChange}
          />
        )
      })
    }
    </>
  )
}

export default UserProfileFieldControls;
